import Vue from 'vue'

const BASE = 'api/employee-growth/admin'

async function unwrap(promise) {
  const res = await promise
  if (!res || !res.data || !res.data.response) {
    throw new Error((res && res.data && res.data.message) || 'Request failed')
  }
  return res.data.data
}

export const getOverview = (from, to) => unwrap(Vue.axios.get(`${BASE}/overview`, { from, to }))
export const getEmployee = (userId, from, to) => unwrap(Vue.axios.get(`${BASE}/employee/${userId}`, { from, to }))
export const getRecognition = (from, to) => unwrap(Vue.axios.get(`${BASE}/recognition`, { from, to }))
export const getTrend = (from, to, userId = null) =>
  unwrap(Vue.axios.get(`${BASE}/trend`, userId ? { from, to, user_id: userId } : { from, to }))
export const giveRecognition = (payload) => unwrap(Vue.axios.post(`${BASE}/recognition`, payload))
export const getInsights = (payload) => unwrap(Vue.axios.post(`${BASE}/ai-insights`, payload, { headers: {}, timeout: 65000 }))
export const getNotes = (userId) => unwrap(Vue.axios.get(`${BASE}/notes`, { user_id: userId }))
export const addNote = (payload) => unwrap(Vue.axios.post(`${BASE}/notes`, payload))
export const deleteNote = (id) =>
  unwrap(
    Vue.axios.delete(`${BASE}/notes/${id}`).catch(e =>
      e && e.data ? e : { data: { response: false, message: (e && e.message) || 'Request failed' } }
    )
  )
